import { labelConstants } from "../../constants";
import { labelService } from "../../services";
import { alertActions } from "../alert.actions";

export const labelActions = {
  getSingleParameter,
  getAllParameters,
  addParameter,
  updateParameter,
  deleteParameter,
  clear,
};

// get single parameter
function getSingleParameter() {}

// get all parameter
function getAllParameters() {
  return (dispatch) => {
    dispatch(request());

    labelService.getAllParameters().then(
      (items) => dispatch(success(items)),
      (error) => dispatch(failure(error))
    );
  };

  function request(params) {
    return { type: labelConstants.GET_ALL_REQUEST, params };
  }
  function success(items) {
    return { type: labelConstants.GET_ALL_SUCCESS, items };
  }
  function failure(error) {
    return { type: labelConstants.GET_ALL_FAILURE, error };
  }
}

// add parameter
function addParameter(name, code,labelType,handleSuccessDialog,successMsg) {
  return (dispatch) => {
    dispatch(request(name, code));

    labelService.addParameter(name, code,labelType).then(
      (parameter) => {
        handleSuccessDialog(successMsg);
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: labelConstants.ADD_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: labelConstants.ADD_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: labelConstants.ADD_FAILURE, error };
  }
}

// update parameter
function updateParameter(id, name, code,labelTypeId) {
  return (dispatch) => {
    dispatch(request(id, name, code,labelTypeId));

    labelService.updateParameter(id, name, code,labelTypeId).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: labelConstants.UPDATE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: labelConstants.UPDATE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: labelConstants.UPDATE_FAILURE, error };
  }
}

// delete parameter
function deleteParameter(id) {
  return (dispatch) => {
    dispatch(request(id));

    labelService.deleteParameter(id).then(
      (parameter) => {
        dispatch(success(parameter));
        dispatch(alertActions.success(parameter));
      },
      (error) => {
        dispatch(failure(error));
        dispatch(alertActions.error(error));
      }
    );
  };

  function request(parameter) {
    return { type: labelConstants.DELETE_REQUEST, parameter };
  }
  function success(parameter) {
    return { type: labelConstants.DELETE_SUCCESS, parameter };
  }
  function failure(error) {
    return { type: labelConstants.DELETE_FAILURE, error };
  }
}

// clear parameter
function clear() {
  return { type: labelConstants.CLEAR };
}
